import { isEmptyString, isNil } from './type-guards';

export const addUrlProtocol = (url: string): string => {
  if (isEmptyString(url) || isNil(url)) {
    return '';
  }

  return url.startsWith('http') ? url : `https://${url}`;
};

/**
 * Converts a data URL (like ones produced by canvas.toDataUrl()) to a file object
 * @param dataUrl The data URL to convert
 * @param filename The name of the file
 */
export const dataUrlToFile = (dataUrl: string, filename: string): File => {
  // Data URLs are generally formatted like this: data:(mimeType);base64,(encodedData)
  // Splitting on the first comma will give us the mime type and the encoded data in two parts
  const dataUrlParts = dataUrl.split(',');

  // grab the encoded data from the second part of the split and decode it
  const fileHash = dataUrlParts[1];
  const byteString = atob(fileHash);

  // grab the mime type from the first part of the split
  const dataUrlMimeType = dataUrlParts[0];
  const mimeString = dataUrlMimeType.split(':')[1].split(';')[0];

  // Allocate an array buffer and byte array to hold the decoded data
  const buffer = new ArrayBuffer(byteString.length);
  const integerArray = new Uint8Array(buffer);

  // Fill the byte array with the decoded data
  for (let i = 0; i < byteString.length; i += 1) {
    integerArray[i] = byteString.charCodeAt(i);
  }

  // Create a file object from the buffer and return it
  return new File([buffer], filename, { type: mimeString });
};
